<template>
  <article ref="rootRef" :class="b(mods)">
    <div v-if="product" :data-scroll-id="product.itemId">
      <meta :content="product.itemId" itemprop="sku" />

      <ga-action
        v-if="product"
        ref="linkRef"
        :class="b('link')"
        :view="null"
        @click.capture="onProductCardClick"
        @mouseenter="$emit('mouseenter-card')"
      >
        <div :class="[b('ratio'), b('ratio_' + ratio)]">
          <ga-product-card-media
            :class="b('media')"
            :faded="isNotInStock"
            :is-adult="product.isAdult"
            :is-hovering="isHovering"
            :max-count="maxCountMedia"
            :media="product.media"
            :product-id="product.itemId"
            :slider-dots-size="sizes.sliderDots"
            :video-strategy="videoStrategy"
            v-on="mediaListeners"
          />
          <ga-product-card-status
            v-if="isNotInStock"
            :class="b('status')"
            :view="productStatus"
          />
        </div>
        <div :class="b('info')">
          <div v-if="slot.has('top-1')" :class="b('info-item')">
            <slot :properties="slot.properties" name="top-1">
              <ga-product-card-attributes
                v-if="product.attributes"
                :class="b('attributes')"
                :data="product.attributes"
                :force-show-attrs="forceShowAttrs"
                :reversed="reversed"
                :size="sizes.attributes"
              />
            </slot>
          </div>

          <div v-if="slot.has('top-2')" :class="[b('top-2'), b('info-item')]">
            <slot name="top-2" :properties="slot.properties" />
          </div>

          <div v-if="slot.has('top-3')" :class="b('info-item')">
            <slot :properties="slot.properties" name="top-3" />
          </div>

          <div :class="b('type')">
            {{ product.type }}
          </div>

          <div :class="b('info-item')">
            <ga-product-card-name
              :brand="product.brand"
              :class="b('name')"
              :name="product.name"
            />
          </div>

          <div v-if="slot.has('bot-1')" :class="b('info-item')">
            <slot :properties="slot.properties" name="bot-1" />
          </div>

          <!-- <div v-if="product.prices" :class="b('info-item')">
            <ga-product-card-price
              :class="b('price')"
              :highlight="highlight"
              :oos="isNotInStock"
              :reversed="reversed"
              :show-currency="showPriceCurrency"
              :size="sizes.price"
              :size-discount="sizes.priceDiscount"
              v-bind="product.prices"
            />
          </div> -->
        </div>
      </ga-action>

      <div :class="b('actions')">
        <div :class="[b('ratio'), b('ratio_' + ratio)]">
          <div v-if="showAddToFavorites" :class="b('favorite')">
            <ga-product-card-favorite-adapter
              :data="product"
              :size="sizes.favorite"
              @click-add-to-favorite="$emit('click-add-to-favorite')"
              @add-to-favorite="$emit('add-to-favorite')"
            />
          </div>
          <div v-if="showAddToCart" ref="cartRef" :class="b('cart')">
            <ga-product-card-cart-adapter
              :cancel-default-add-to-cart="cancelDefaultAddToCart"
              :cancel-default-update-qty="cancelDefaultUpdateQty"
              :data="product"
              :loading="cartLoading"
              :disabled="isNotInStock"
              :counter-cart-class="b('counter-cart-button')"
              :size="sizes.cart"
              @add-to-cart="$emit('add-to-cart', { cartData: $event })"
              @counter-increase="$emit('cart-counter-increase', $event)"
              @counter-decrease="$emit('cart-counter-decrease', $event)"
              @click-add-to-cart="
                $emit('click-add-to-cart', { cartData: $event })
              "
              @open-preview="$emit('open-preview', { cartData: $event })"
            />
          </div>
        </div>
        <ga-product-card-status v-if="isNotInStock" :view="productStatus" />
      </div>
    </div>

    <div v-if="!product && skeletonEnable" :class="b('skeleton')">
      <div :class="[b('ratio'), b('ratio_' + ratio), b('skeleton-media')]" />
      <div :class="b('skeleton-info')">
        <div :class="b('skeleton-type')">
          <span :class="b('skeleton-line')" />
          <span :class="b('skeleton-line')" />
        </div>
        <div :class="b('skeleton-name')">
          <span :class="b('skeleton-line')" />
          <span :class="b('skeleton-line')" />
        </div>
        <!-- <div :class="b('skeleton-price')">
          <span :class="b('skeleton-line')" />
        </div> -->
      </div>
    </div>
  </article>
</template>

<script src="./product-card-vertical.scripts.js" />

<style lang="scss" module src="./product-card-vertical.styles.scss" />
